import {
  showErrorSnackbar,
  showSuccessSnackbar
} from 'components/shared/Snackbar';
import { useQueryClient } from 'react-query';
import { mutations } from 'RestAPIs/rapini';

const useDeleteDayLimitArrangement = () => {
  const queryClient = useQueryClient();
  return mutations.useDeleteDayLimitArrangement({
    onSuccess: async () => {
      showSuccessSnackbar();
      await queryClient.invalidateQueries(['dayLimitArrangements', 'list']);
    },
    onError: () => {
      showErrorSnackbar();
    }
  });
};

export default useDeleteDayLimitArrangement;
